import { Flex } from "src/elements";
import styled from "styled-components";

export const PLANOGRAM_LAYER_Z_INDEX = {
  bays: 0,
  shelves: 1,
  containers: 2,
} as const;

export const InnerWrapper = styled(Flex)<{ $zIndex: number }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${({ $zIndex }) => $zIndex};
  pointer-events: none;
`;
